export const outwardpurposeOptions = [
  { key: 'Digitization', value: 'Digitization', text: 'Digitization' },
  { key: 'Restoration', value: 'Restoration', text: 'Restoration' },
  { key: 'Film Festival', value: 'Film Festival', text: 'Film Festival' },
  {
    key: 'Move to own vault',
    value: 'Move to own vault',
    text: 'Move to own vault',
  },
  {
    key: 'Move to other vault',
    value: 'Move to other vault',
    text: 'Move to other vault',
  },
];
